import React from 'react';
import PropTypes from 'prop-types';
import Loading from '../../../shared/loading';
import defaultOnErrorHandler from '../../../shared/default-on-error-handler';
import debounceAction from '../../../shared/debounce-action';
import searchUser from '../../../services/lwadmin/users/search-service';

export const USER_SEARCH_COHORT = {
  all: 'all',
  contributors: 'contributors',
};

export class UserSearchControl extends React.Component {
  static propTypes = {
    onUserSelected: PropTypes.func,
    cohort: PropTypes.string,
    filter: PropTypes.func,
    searchPlaceholder: PropTypes.string,
  }

  static defaultProps = {
    onUserSelected: null,
    cohort: USER_SEARCH_COHORT.all,
    filter: () => true,
    searchPlaceholder: '',
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      search: '',
      users: [],
      selectedUser: null,
      hasDoneSearch: false,
    };

    this.updateSearch = debounceAction({
      getCurrentValue: () => this.state.search,
      actionPromise: () => searchUser(props.cohort, this.state.search),
      onBeforeAction: () => this.loading.start(),
      onNext: result => this.setState({
        users: result.data.users.filter(props.filter),
        hasDoneSearch: true,
      }),
      onError: e => defaultOnErrorHandler(e, 'Error performing search'),
      onAfterAction: () => this.loading.stop(),
      actionDelay: 300,
    });
  }

  componentDidMount() {}

  handleSearchChange(e) {
    const search = e.target.value;

    this.setState({ search }, () => this.updateSearch());
  }

  selectUser(e, user) {
    e && e.preventDefault && e.preventDefault();

    this.setState(
      { selectedUser: user },
      () => this.props.onUserSelected && this.props.onUserSelected(user),
    );
  }

  clear() {
    this.setState({
      search: '',
      users: [],
      selectedUser: null,
      hasDoneSearch: false,
    }, () => this.updateSearch.resetInitialValue());
  }

  render() {
    return (
      <div>
        <div className="form-group">
          <input
            value={this.state.search}
            onChange={e => this.handleSearchChange(e)}
            onBlur={() => this.updateSearch}
            placeholder={this.props.searchPlaceholder || ''}
          />
        </div>
        <div className="form-group">
          <Loading ref={c => (this.loading = c)} variant="small">
            {this.state.users.length > 0 && (
              <ul className="list-box">
                {this.state.users.map(user => (
                  <li
                    key={user.id}
                    className={`${this.state.selectedUser === user ? 'selected' : ''}`}
                  >
                    <a href="#" onClick={e => this.selectUser(e, user)}>
                      {`${user.name} (${user.email})`}
                    </a>
                  </li>
                ))}
              </ul>
            )}
            {this.state.hasDoneSearch && this.state.users.length === 0 && <p>No results</p>}
          </Loading>
        </div>
      </div>
    );
  }
}
